module.exports = __webpack_public_path__ + "static/media/app-icon.4bebc99d.png";